<script setup lang="ts">
import { useRoute } from 'vue-router';
import { useTranslations } from '../composables/useTranslations';
import { computed } from 'vue';

const route = useRoute();
const t = useTranslations();

const isRoomPage = computed(() => route.path.includes('/rooms/'));
</script>

<template>
  <footer v-if="!isRoomPage" class="bg-gray-800 text-white py-12 px-6">
    <div class="flex flex-col md:flex-row justify-between items-center">
      <div class="flex items-center">
        <span class="text-sm">
          &copy; {{ new Date().getFullYear() }} Language Rooms.
          {{ t.allRightsReservedFunny }}
        </span>
      </div>
    </div>
  </footer>
</template>
